import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, inr } from "@/lib/api";

const chime = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [880, 1320].forEach((f, i) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.frequency.value = f; o.connect(g); g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.18;
      g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      o.start(t); o.stop(t + 0.36);
    });
  } catch { /* audio unsupported */ }
};

const speak = (amount) => {
  if (!window.speechSynthesis) return;
  const u = new SpeechSynthesisUtterance(`Received ${Number(amount).toLocaleString("en-IN")} rupees on Yes Pay Bizz`);
  u.lang = "en-IN"; u.rate = 0.95;
  setTimeout(() => window.speechSynthesis.speak(u), 450);
};

export const LivePayments = () => {
  const { user, setUser, bump, soundOn } = useAuth();
  const seen = useRef(null);
  const soundRef = useRef(soundOn);
  soundRef.current = soundOn;
  const active = user && user.role === "user";

  useEffect(() => {
    if (!active) { seen.current = null; return; }
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get("/me/transactions", { params: { limit: 10 } });
        if (!alive) return;
        if (seen.current === null) { seen.current = new Set(data.map((t) => t.id)); return; }
        const fresh = data.filter((t) => !seen.current.has(t.id));
        if (!fresh.length) return;
        fresh.forEach((t) => seen.current.add(t.id));
        const me = await api.get("/auth/me");
        if (alive) { setUser(me.data); bump(); }
        fresh.filter((t) => t.wallet === "collection" && t.type === "credit" && t.category === "manual").reverse().forEach((t) => {
          toast.success(`${inr(t.amount)} received on YesPayBizz`, { description: t.utr ? `UTR ${t.utr}` : undefined });
          if (soundRef.current) { chime(); speak(t.amount); }
        });
      } catch { /* retry next tick */ }
    };
    poll();
    const id = setInterval(poll, 5000);
    return () => { alive = false; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  return null;
};
